<template>
	<BaseTooltip :title="isSaved == true ? langs.card.remove_company[locale] : langs.card.save_company[locale]">
		<div
			@click.stop="toggleSaved"
			class="w-dj-40 h-dj-40 flex justify-center items-center rounded-full cursor-pointer"
			:class="isSaved == true ? 'bg-dj-pink-light' : 'bg-dj-grey-light/75'"
		>
			<span
				class="material-icons-outlined transition-colors"
				:class="isSaved == true ? 'text-dj-red hover:text-dj-gray' : 'text-white hover:text-dj-red'"
			>
				favorite
			</span>
		</div>
	</BaseTooltip>
</template>

<script lang="ts">
import BaseTooltip from "~/ui-kit/components/BaseTooltip.vue";
import { defineComponent, type PropType } from "vue";
import type { JobCardsLang } from "~/ui-kit/types/types";

export default defineComponent({
	name: "DjCardSaveJob",
	components: { BaseTooltip },
	props: {
		isSaved: {
			type: Boolean,
			default: false,
		},
		langs: {
			type: Object as PropType<JobCardsLang>,
			default: () => {
				return {};
			},
		},
		locale: {
			type: String,
			default: "hu",
		},
	},
	setup(props, { emit }) {
		function toggleSaved() {
			emit("toggleSaved");
		}

		return {
			toggleSaved,
		};
	},
});
</script>
